import * as React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { Button, Graphic, MarkdownHTML } from '..';
import { paths } from '../../routes';
import env from '../../utils/env';

type ErrorFallbackProps = {
  error: Error;
  resetErrorBoundary: (...args: Array<unknown>) => void;
};

export function ErrorFallback({
  error,
  resetErrorBoundary,
}: ErrorFallbackProps) {
  return (
    <div
      role="alert"
      className="flex flex-col items-center justify-center h-full"
    >
      <h3 className="text-pos-red text-xl font-medium mb-2">Whoops !!!</h3>
      <span>
        <pre className="inline-flex text-base whitespace-pre-wrap text-center w-ful">
          {error.message ||
            'Something unusual happened. Kindly retry your last action.'}
        </pre>
      </span>

      <Graphic
        className="w-[250px] tablet:w-[550px] transform rotate-3 transition hover:scale-105 duration-700 ease-in-out hover:rotate-3"
        id="graphic500"
      />

      <Button
        label="Try again!"
        onClick={resetErrorBoundary}
        className="!px-2 mt-10 !shrink-0"
      />

      <MarkdownHTML
        className="text-pos-black text-xbase mt-6 text-center"
        content={`If this persists, please reach out to our [support team.](${paths.LANDING_SUPPORT_URL_PATH})`}
      />
    </div>
  );
}

function ErrorBoundary({ children }: { children: JSX.Element }) {
  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        window.location.assign(paths.DASHBOARD_URL_PATH);
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
}

export default ErrorBoundary;
